<template>
  <div class="left-table-list" >
    <div class="order-table-toolbar">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24" style="width: 100%">
            <div style="overflow: hidden;display: flex;margin-top: 0px" class="table-page-search-submitButtons">
              <div>
                <a-button type="primary" @click="newCar" icon="plus-circle"
                          style="height: 36px !important;border-radius: 18px;font-size: 14px">绑定车辆</a-button>
              </div>
              <div class="common-btn-box" >
                <div class="common-btn-box-span" @click="reloadBd()" v-show="selectedRowKeys.length===1">
                  <icon-font class="common-btn-icon" :type="checkIsBd()?'icon-jiebang':'icon-bangding'"></icon-font>
                  <span>{{checkIsBd()?'绑定' : '解绑'}}</span>
                </div>
                <div class="common-btn-box-span" @click="clearSupper" v-show="!selectedRowKeys.length">
                  <icon-font class="common-btn-icon" type="icon-shuaxin"></icon-font>
                  <span>重新加载</span>
                </div>
              </div>
              <div class="car-more-box" v-if="dataSource && dataSource.length && dataSource[0].bdName">
                <img :src="getFileAccessHttpUrl(dataSource[0].bdAvatar)" v-if="dataSource[0].bdAvatar"/>
                <span>{{dataSource[0].bdName}}</span>
                <span>更新于{{dataSource[0].bdTime}}</span>
              </div>
              <div class="car-more-box" v-else>

              </div>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div>
  <a-table
    ref="table"
    size="middle"
    :scroll="{x:true}"
    rowKey="id"
    :columns="columns"
    :dataSource="dataSource"
    :pagination="ipagination"
    :loading="loading"
    :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
    :customHeaderRow="customHeaderRow"
    :customRow="customRow"
    class="j-table-force-nowrap"
    @change="handleTableChange">

    <template slot="bdNameSlot" slot-scope="text,record">
      <div >
        <img v-if="record.bdAvatar" :title="text" :src="getImgView(record.bdAvatar)"  alt="" style="width:20px;height: 20px;font-size: 12px;font-style: italic;border-radius:50%"/>
        <span v-else>{{text}}</span>
        <span v-if="record.bdAvatar" style="margin-left: 10px">{{text}}</span>
      </div>
    </template>
    <template slot="bdSlot" slot-scope="text,record">
      <div>
        <span v-if="text===0" style="color:rgb(24, 144, 255)">已绑定</span>
        <span v-if="text===1">已解绑</span>
      </div>
    </template>
<!--    <span slot="action" slot-scope="text, record">-->
<!--           <a-popconfirm title="确定解绑吗?" @confirm.stop="() => revokeBd(record)" v-if="record.delFlag===0">-->
<!--             <a target="_blank"  class="tb-span-click">解绑</a>-->
<!--           </a-popconfirm>-->
<!--          <a-popconfirm title="确定绑定吗?" @confirm.stop="() => reloadBd(record)" v-if="record.delFlag===1">-->
<!--             <a target="_blank"  class="tb-span-click">绑定</a>-->
<!--           </a-popconfirm>-->
<!--        </span>-->

  </a-table>

  </div>
    <car-modal-info ref="carForm" @ok="loadList"></car-modal-info>
  </div>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import {  getAction ,getFileAccessHttpUrl} from '@/api/manage'
  export default {
    name: 'CarTable',
    components: { CarModalInfo: () => import('@views/dm5/CarModalInfo')},
    mixins:[JeecgListMixin, mixinDevice],
    props: {
      driverId:{
        type:Number,
        default:''
      },
      model:{
        type:Object,
        default:{}
      }
    },data(){
      return {
        columns: [
          {
            title:'车牌号',
            align:"left",
            dataIndex: 'licensePlateNumber'
          },
          {
            title:'车辆品牌',
            align:"left",
            dataIndex: 'brandName',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title:'车系',
            align:"left",
            dataIndex: 'modelName',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title: '绑定状态',
            align:"left",
            dataIndex: 'delFlag',
            scopedSlots: { customRender: 'bdSlot' },
          },
          {
            title:'绑定人',
            align:"left",
            width:100,
            dataIndex: 'bdName',
            scopedSlots: { customRender: 'bdNameSlot' }
          },
          {
            title: '绑定时间',
            align:"left",
            dataIndex: 'bdTime',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"left",
            width:140,
            fixed:"right",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/dm/dmDriver/queryCarBdList"
        },disableMixinCreated:true,
        getFileAccessHttpUrl:getFileAccessHttpUrl
      }
    },methods:{
      loadList(){
        this.queryParam.driverId = this.driverId;
        this.queryParam.type =0;
        this.loadData();
      },bdCar(){
        this.$refs.carForm.edit(this.record);
      },revokeBd(record){
        var param = {
          "driverId":record.driverId,
          "carId":record.carId
        }
        getAction("/dm/dmDriver/revokeDriver",param).then((res)=>{
          if(res.success){
            this.$message.success(res.message);
            // record.isUse = param.isUse;
            this.loadData(1);
            this.$emit("ok");
          }else{
            this.$message.warning(res.message);
          }
        })
      },reloadBd(){
        let record = this.getRecord();
        if(record.delFlag==0){
          this.revokeBd(record)
        }else{
          var param = {
            "driverId":record.driverId,
            "carId":record.carId
          }
          getAction("/dm/dmDriver/reloadDriver",param).then((res)=>{
            if(res.success){
              this.$message.success(res.message);
              // record.isUse = param.isUse;
              this.loadData(1);
              this.$emit("ok");
            }else{
              this.$message.warning(res.message);
            }
          })
        }

      },viewInfo(record){
        this.$emit("to",record.carId);
      },customRow(record){
        let that = this;
        let clas = "row-class"
        if(record.delFlag===1){
          clas +=" hui-class"
        }
        return {
          class:clas,
          on:{
            click:(e)=>{
              if(e.target._prevClass=='ant-checkbox-input'
                || e.target._prevClass=='ant-table-selection-column'
                || e.target._prevClass=='tb-span-click'){
                return;
              }
              if(!record.driverId){
                return;
              }
              if(event.button==0){
                if(that.viewInfo){
                  that.viewInfo(record);
                }
              }

            }
          }
        }
      },getImgView(text){
        if(text && text.indexOf(",")>0){
          text = text.substring(0,text.indexOf(","))
        }
        return getFileAccessHttpUrl(text)
      },newCar(){
        this.$refs.carForm.addCar(this.driverId);
      },checkIsBd(){
       if(!this.selectedRowKeys.length || this.selectedRowKeys.length>1){
         return false;
       }
       let item = this.getRecord();
       console.log( item)
       return item.delFlag===1;
      },getRecord(){
        let id = this.selectedRowKeys[0];
        return this.dataSource.find(item=>item.id===id);
      }
    }
  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
@import '~@assets/less/dm/tableList.less';
@import '~@assets/less/dm/newTable.less';
/deep/ th[key='selection-column']{
  padding: 12px 22px !important
}
.left-table-list{
  margin-top: 0 !important;
}
.car-more-box{
  width: 376px;
  background: #fff;
  border-radius: 18px;
  padding:7px 18px;
}
.car-more-box img{
  width: 20px;
  height: 20px;
  border-radius: 50%;
  vertical-align: sub;
}
.car-more-box span{
  margin-left: 9px;
}
</style>